export const CardBackContent = ({message}) => (
  <div className="flip-card-back__content">
    <span className="flip-card-back__content__text">
      {message || (
        <>
          Optional: Your message will display here. If you don’t add one, your card will not have a
          backside.
        </>
      )}
    </span>
  </div>
);
